import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";

const ClientContext = createContext(null);

export function ClientProvider({ children }) {
  const { user, seesAll } = useAuth();
  const clients = user?.workspaces || [];
  const [activeId, setActiveId] = useState(localStorage.getItem("be_active_client") || null);

  // Reconcile active workspace with what this user is allowed to see.
  useEffect(() => {
    if (!clients.length) return;
    setActiveId((prev) => {
      const valid = clients.find((c) => c.id === prev);
      const next = valid ? prev : clients[0]?.id || null;
      if (next) localStorage.setItem("be_active_client", next);
      return next;
    });
  }, [user]); // eslint-disable-line react-hooks/exhaustive-deps

  const setActive = (id, force = false) => {
    if (!force && !clients.find((c) => c.id === id)) return; // never switch to a workspace you can't access
    setActiveId(id);
    localStorage.setItem("be_active_client", id);
  };

  const activeClient = clients.find((c) => c.id === activeId) || null;
  const canSwitch = seesAll && clients.length > 1;

  return (
    <ClientContext.Provider value={{ clients, activeClient, activeId, setActive, canSwitch, loading: false }}>
      {children}
    </ClientContext.Provider>
  );
}

export const useClient = () => useContext(ClientContext);
